import { Component, OnInit, Input, Renderer2, ViewEncapsulation,
  EventEmitter, Output, ChangeDetectorRef, OnChanges, ViewChild,
  ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import _ from 'lodash';
import { CommonService } from '../services/common.service';
import { TableSearchComponent } from '../table-search/table-search.component';;
import { ItemListTableService } from '../item-list-table/item-list-table.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { IPageInfo } from 'ngx-virtual-scroller';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { CheckboxComponent } from '../component/checkbox/checkbox.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { NoItemsComponent } from '../no-items/no-items.component';
import { TranslateModule } from '@ngx-translate/core';
import { IsEmpty } from '../pipes/is-empty.pipe';
import { TrimLower } from '../pipes/trim-lower-str.pipe';
import { GetIconName } from '../pipes/get-Icon-name.pipe';
import { HighlightPipe } from '../pipes/highlight-char.pipe';
import { FilterPipe } from '../pipes/filter-pipe';
import { DateFormater } from '../pipes/date-formater.pipe';
@Component({
    selector: 'app-landing-table',
    templateUrl: './landing-table.component.html',
    styleUrls: ['./landing-table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, TableSearchComponent, CheckboxComponent, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, MatMenuTrigger, MatMenu, MatMenuItem, NoItemsComponent, TranslateModule, IsEmpty, TrimLower, GetIconName, HighlightPipe, FilterPipe, DateFormater]
})
export class LandingTableComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  constructor(
    public _tableService: ItemListTableService,
    private cdRef: ChangeDetectorRef,
    private _commonService: CommonService,
    public _eR: ElementRef,
    public renderer: Renderer2,
    public deviceInfo: DeviceDetectorService
    ) {
    // this.originalData = this.tableInputs.tableData;
    console.log(deviceInfo.getDeviceInfo());
  }
  @ViewChild(TableSearchComponent) tableSearch: TableSearchComponent;
  @ViewChild('scrollcontainer') scrollcontainer: ElementRef;
  @ViewChild('appcontainer') appcontainer: ElementRef;
  @ViewChild('apptablerow') apptablerow: ElementRef;
  @ViewChild('searchBar') searchBar: ElementRef;
  @ViewChild('appTittle') appTittle: ElementRef;
  @ViewChild('scroll') cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  windowHeight: number;
  tableData: any = [];
  tableHeader: any = [];
  tableStyle: any = [];
  tableColumn: any = [];
  tableId: any;
  tableIcon: any = [];
  headerIcon: any = [];
  showIcon = false;
  showCheckBox = false;
  disableCheckBox = false;
  showMore = false;
  disableMore = false;
  showContentIcon = false;
  SelectedData: any = [];
  IsCheckAll = false;
  moreOptions: any = [];
  orderId: any = [];
  orderBy: string;
  sortOrder = 'desc';
  currentId: Number;
  filterData: any;
  filter = [];
  searchData = [];
  showSort = true;
  noSearchData = true;
  sortByOptions: any;
  defaultSort: string;
  page = 0;
  pagePerCount: number;
  countRecords = 0;
  tempSliceArray: any = [];
  timeOut: any;
  showButtons = false;
  showItemList: any;
  isExpand: any = false;
  @Input() tableInputs;
  @Input() dataInput;
  @Input() datavlaue;
  @Input() highlightText;
  @Input() searchText;
  @Input() searchKey;
  @Input() filterArray;  // Filter array form the Reqisation
  @Input() customRowClass;
  @Input() detectChange;
  @Input() checkOnlineStatusforClick;
  @Input() showFilterIcon=true;
  
  @Output() RowSelectEmitter: EventEmitter<any> = new EventEmitter();
  @Output() CurrentRowSelectedEmitter: EventEmitter<any> = new EventEmitter();
  @Output() RowClicked: EventEmitter<any> = new EventEmitter();
  @Output() MoreOptionsClicked: EventEmitter<any> = new EventEmitter();
  @Output() filterValue: EventEmitter<any> = new EventEmitter();
  @Output() sortEmit: EventEmitter<any> = new EventEmitter();
  @Output() filterEmit: EventEmitter<any> = new EventEmitter();
  @Output() checkStatusToFilter: EventEmitter<any> = new EventEmitter();
  @Output() checkStatusToSort: EventEmitter<any> = new EventEmitter();
  @Output() emitOffineforSearch: EventEmitter<any> = new EventEmitter();
  @Output() totalDataBinded: EventEmitter<any> = new EventEmitter();
  @Output() apiSearchemit: EventEmitter<any> = new EventEmitter();
  @Output() sortchanged: EventEmitter<any> = new EventEmitter();
  @Output() syncEmitter: EventEmitter<any> = new EventEmitter();


  searchoptionalParams: { 'placeholder': any; 'icon-place': string; 'searchParam': string[]; };
  showSearch: any=false;
  searchParms: any;
  searchApplied: any;
  originalData: any;
  showRowTitle: any;
  showRowTitleData: any;
  hideOfflineTitle = false;
  showNodata = true;
  customClass: any;
  someClass: any;
  indexArray: any = [];
  showDropshipBeside: string;
  showPriorityBeside: string;
  priorityKey: string;
  resizeWidth: any;
  resizeParameters: any;
  rowTitleClass: any;
  scrollDataArray: any = [];
  customTableData: any[];
  sortData: any[];
  isCustomTableData = false;
  public loggedInSiteId = 0;
  scrollEventEmitter: any;
  showHeader = false;
  showNoDataFullScreen = false;
  currentTransformPixel: any;
  intial = true;
  rowHeight = 0;

  selectedRowIndex: number;
  expandedHeight: number;
  index: number;
    trackFunction(index, data) {
    return index;
  }

  changed=false;
  order='desc';
  fetchMore(event: IPageInfo) {
    if (event.endIndex !== this.tableInputs.tableData.length-1 || !this.tableInputs.tableData.length) return;
    if( this.tableInputs && this.tableInputs.hasOwnProperty('bottomReached')){
      if( this.tableInputs && this.tableInputs.hasOwnProperty('totalCount') ){
        const totalTableCount = this.tableInputs.totalCount;        
        if( this.tableInputs.tableData.length < totalTableCount ){
          this.tableInputs.bottomReached(this.tableData.length)
       }      
      }
      
    }
     
  }

  // sortingOptionChanged(event:any){
  //   this.changed=true;    
  //   this.tableInputs.tableData=[];
  //   // this.tableInputs.bottomReached(0,event.order,event.key)
  //   this.sortchanged.emit(event);
  //   document.getElementsByClassName('selfScroll')[0].scrollTop = 0;
  // }
  sortingOptionChanged(event: any) {
    this.changed = true;
    this.tableInputs.tableData = [];
    this.sortchanged.emit(event);
    const scrollElement = document.getElementsByClassName('selfScroll')[0] as HTMLElement | undefined;
  
    if (scrollElement) {
      scrollElement.scrollTop = 0;
    } else {
      console.log("Element with class 'selfScroll' not found.");
    }
  }
  
  ngOnInit() {
    if (window.matchMedia('screen and (max-width: 1024px)').matches) {
      this.showHeader = false;
    } else {
      this.showHeader = true;
    }
    // document.getElementsByClassName('section-container')[0].scrollTop = 0;selfScroll
  }

  getIconClass(i: number, showContentIcon: boolean, header: string, data: any): string {
    if (this.tableId === 'requisitions' || 
        this.tableId === 'allrequisition' || 
        this.tableId === 'transfers' || 
        this.tableId === 'alltransfers' || 
        this.tableId === 'offlineLandRequisitions' || 
        this.tableId === 'offlineLandTransfers' || 
        this.tableId === 'offline-requisitions' ||
        this.tableId === 'offlineTransfers' ||
        this.tableId === 'recentTransfers' ||
        this.tableId === 'transRequsitionDetails') {
      return this.tableIcon[i] !== '' ? 'before-location-icon ' + this.tableIcon[i] : '';
    } else {
      if (this.tableIcon[i] !== '') {
        return this.tableIcon[i];
      } else {
        if (showContentIcon && (header === 'status') && (typeof data.statusText === 'string')) {
          return 'color-' + data.statusText.trim().toLowerCase();
        } else {
          return '';
        }
      }
    }
  }

  setTableWidth() {
    let overallgivenwidth = 0,
      ts;

    if (this.tableStyle) {
      const currTable = document.getElementById(this.tableId);
      for (ts = 0; ts < this.tableStyle.length; ts++) {
        if (currTable) {
          (<HTMLElement>currTable.getElementsByClassName('header-col')[ts])['style'].width = this.tableStyle[ts] + '%';
          const tableRow = currTable.getElementsByClassName('table-row');
          for (let tb = 0; tb < tableRow.length; tb++) {
            const bodyColumn = tableRow[tb].getElementsByClassName('body-col');
            for (let bc = 0; bc < bodyColumn.length; bc++) {
              if (bodyColumn[bc]) {
                (<HTMLElement>bodyColumn[bc]).style.width = this.tableStyle[bc] + '%';
              }
            }
          }
        }
        overallgivenwidth += Number(this.tableStyle[ts]);
      }
    }
  }



  getGetAllTableData(data) {
    if (data.length > 0) {
      this.tableColumn = Object.keys(data[0]);
      if (this.tableColumn[0] === 'checked') {
        this.tableColumn.splice(0, 1);
      }
      if (this.tableColumn.findIndex(x => x === 'statusText') > 0) {
        this.tableColumn.splice(this.tableColumn.findIndex(x => x === 'statusText'), 1);
      }
      if (this.tableColumn.findIndex(x => x === 'disableCheckBox') > 0) {
        this.tableColumn.splice(this.tableColumn.findIndex(x => x === 'disableCheckBox'), 1);
      }
      if (this.tableColumn.findIndex(x => x === 'disablecopy') > 0) {
        this.tableColumn.splice(this.tableColumn.findIndex(x => x === 'disablecopy'), 1);
      }
      ['approvalStatusId', 'LocationId', 'ToLocationId', 'FromLocId', 'fromLocationId', 'toLocationId'].forEach(field => {
        const id = this.tableColumn.findIndex(x => x === field);
        if (id > 0) { this.tableColumn.splice(id, 1); }
      });
    }
  }

  /******
   * @function reservedFilter()
   * @params Obj
   * @description Second level Emit Function from the Grand child
   */
  reservedFilter(receivedFilter) {
    if (this.tableSearch) {
      this.tableSearch.clearSearchValue();
    }
    if(this.originalData.length>0){
      this.originalData.map((el)=>{
        el.checked = false
      })
    } 
    this.SelectedData=[]
    const data = this._tableService.tableFilter(this.originalData, this.customTableData,
      this.tableId, receivedFilter, this.isCustomTableData, this.filterArray);
    if (data.length === 0) {
      this.showNodata = true;
    } else {
      this.showNodata = false;
    }
    this.searchData = data;
    this.sortData = data;
    this.customTableData = data;
    this.isCustomTableData = true;
    this.tableData = [];
    this.tableData = data;
    const sortArray = [this.sortOrder, this.orderBy];
    this.sortTable(sortArray);
    this.page = 0;
    this.getScroll();
    this._commonService.iconShow = receivedFilter.some(
      ele => ele.innervalue.some((x: any) => x.checked === true) ||
             (ele.filterType === 'daterange' && ele.fromDate != null));
    this.filterEmit.emit(this.searchData);
    this.filterValue.emit(receivedFilter);
    this.updateTableHeight();
  }

  /******
   * @function  clearData()()
   * @params Obj
   * @description Clear the all data
   */
  clearData() {
    if (this.filterArray.length !== 0) {
      this.filterArray.forEach(element => {
        element.innervalue.forEach(item => {
          item.checked = false;
        });
      });
      this.filter.forEach(element => {
        element.val = [];
      });
      this.tableData = [];
      this.tableData = this.originalData;
      this.searchData = this.tableData;
      if (this.tableData.length === 0) {
        this.showNodata = true;
      } else {
        this.showNodata = false;
      }
      this._commonService.iconShow = (this.indexArray.length > 0) ? true : false;
    }

  }






  /**
   * @method AfterviewData
   * @function ngAfterContentInit
   * @description Get scroll data emiter from the Service and Subcribe the Scroll Event;
   * @input Params None
   * @outPut triger the this.getScroll(data) method
   */
  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterContentInit() {
    this.scrollEventEmitter =
      this._commonService.scrollEventEmitter
        .subscribe((data) => {
          if (((data.target.scrollHeight / (data.target.offsetHeight + data.target.scrollTop)) * 100) > 70) {
            this.getScroll(data); // Uncommented for Bug 15914
          }
        });
  }



  /**
 * @method scroll event methd
 * @function getScroll(e?: any)
 * @param e optional paramater scroll @event
 * @description get body height and row height array push to one by one
 * @input params NONE
 * @output Array of object;
 */

  getScroll(e?: any) {
    // Uncommented for Bug 15914
    if ( e ) {
      if ( e.currentTarget.scrollTop > 2 && ( this.tableInputs.tableId === 'alltransfers' ||
       this.tableInputs.tableId === 'recentTransfers')) {
       this.renderer.addClass(this.searchBar.nativeElement, 'fixed-search-bar');
       const ParentNode  = document.querySelector('.mat-tab-group');
       const MovingNode  = document.querySelector('.search-bar');
       const ReferenceNode  = document.querySelector('.mat-tab-body-wrapper');
       ParentNode.insertBefore(MovingNode, ReferenceNode);
      }
     }
    const bodyHeight = document.getElementById('app-container').clientHeight;
    const rowHeight = 100;
    const recordsPerCell = bodyHeight / rowHeight;
    const recordsCount = Math.ceil(recordsPerCell) + 10;
    this.countRecords = recordsCount + this.page;
    const data = this.isCustomTableData ? this.customTableData : this.originalData;
    // this.tableData = data;
    // this.tableData = [...this.tableData];
    // if (data && data.length > 0) {
    //   data.slice(this.page, this.countRecords).forEach(element => {
    //     this.tableData.push(element);
    //     this.page++;
    //   });
    //   if (!(this.cdRef as ViewRef).destroyed) {
    //     this.cdRef.detectChanges();
    //   }
    // }
    this.showButtons = true;
    this.totalDataBinded.emit([event, false]);

  }

  ngOnDestroy() {
    clearTimeout(this.timeOut);
    this.cdRef.detach();
    if (this.scrollEventEmitter) {
      this.scrollEventEmitter.unsubscribe();
    }
    // this.subscription.unsubscribe();
  }

  ngOnChanges(changes?) {
    console.log('taaaaa', this.tableInputs);
    this.filterData = this.filterArray;
    this.customRowClass = this.tableInputs.hasOwnProperty('customRowClass') ? this.tableInputs.customRowClass : {};
    this.tableData = [];
    this.originalData = _.cloneDeep(this.tableInputs.tableData);
    this.tableData = this.originalData ? this.originalData : this.tableData;
    this.searchData = this.originalData;
    this.sortData = this.originalData;
    this.tableStyle = this.tableInputs.tableStyle;
    this.tableHeader = this.tableInputs.tableHeader;
    this.tableId = this.tableInputs.tableId;
    this.showIcon = this.tableInputs.showIcon;
    this.showFilterIcon = this.tableInputs.hasOwnProperty('showFilterIcon') ? this.tableInputs.showFilterIcon : true ;
    this.showItemList = this.tableInputs.hasOwnProperty('showItemList') ? this.tableInputs.showItemList : false;
    this.tableIcon = this.tableInputs.hasOwnProperty('icons') ? this.tableInputs.icons : [];
    this.headerIcon = this.tableInputs.hasOwnProperty('headerIcons') ? this.tableInputs.headerIcons : [];
    this.showCheckBox = this.tableInputs.hasOwnProperty('showCheckBox') ? this.tableInputs.showCheckBox : false;
    this.disableCheckBox = this.tableInputs.hasOwnProperty('disableCheckBox') ? this.tableInputs.disableCheckBox : false;
    this.showMore = this.tableInputs.hasOwnProperty('showMore') ? this.tableInputs.showMore : false;
    this.disableMore = this.tableInputs.hasOwnProperty('disableMore') ? this.tableInputs.disableMore : false;
    this.showContentIcon = this.tableInputs.hasOwnProperty('showContentIcon') ? this.tableInputs.showContentIcon : false;
    this.showSearch = this.tableInputs.hasOwnProperty('showSearch') ? this.tableInputs.showSearch : false;
    this.showRowTitle = this.tableInputs.hasOwnProperty('showRowTitle') ? this.tableInputs.showRowTitle : false;
    this.showRowTitleData = this.tableInputs.hasOwnProperty('showRowTitleData') ? this.tableInputs.showRowTitleData : false;
    this.hideOfflineTitle = this.tableInputs.hasOwnProperty('hideOfflineTitle') ? this.tableInputs.hideOfflineTitle : false;
    this.moreOptions = this.tableInputs.hasOwnProperty('moreOptions') ? this.tableInputs.moreOptions : [];
    this.searchParms = this.tableInputs.hasOwnProperty('searchParms') ? this.tableInputs.searchParms : false;
    this.searchApplied = this.tableInputs.hasOwnProperty('searchApplied') ? this.tableInputs.searchApplied : [];
    this.customClass = this.tableInputs.hasOwnProperty('customClass') ? this.tableInputs.customClass : '';
    this.orderId = this.tableInputs.hasOwnProperty('orderId') ? this.tableInputs.orderId : [];
    this.orderBy = this.tableInputs.hasOwnProperty('orderBy') ? this.tableInputs.orderBy : 'timestamp';
    this.sortOrder = this.tableInputs.hasOwnProperty('sortOrder') ? this.tableInputs.sortOrder : 'desc';
    this.showDropshipBeside = this.tableInputs.hasOwnProperty('showDropshipBeside') ? this.tableInputs.showDropshipBeside : '';
    this.showSort = this.tableInputs.hasOwnProperty('showSort') ? this.tableInputs.showSort : true;
    this.showPriorityBeside = this.tableInputs.hasOwnProperty('showPriorityBeside') ? this.tableInputs.showPriorityBeside : '';
    this.priorityKey = this.tableInputs.hasOwnProperty('priorityKey') ? this.tableInputs.priorityKey : '';
    this.resizeWidth = this.tableInputs.hasOwnProperty('resizeWidth') ? this.tableInputs.resizeWidth : false;
    this.resizeParameters = this.tableInputs.hasOwnProperty('resizeParameters') ? this.tableInputs.resizeParameters : {};
    this.rowTitleClass = this.tableInputs.hasOwnProperty('rowTitleClass') ? this.tableInputs.rowTitleClass : '';
    this.noSearchData = this.tableInputs.hasOwnProperty('noSearchData') ? this.tableInputs.noSearchData : true;
    this.showNoDataFullScreen = this.tableInputs.hasOwnProperty('showNoDataFullScreen') ? this.tableInputs.showNoDataFullScreen : false;
    this.sortByOptions = this.tableInputs.sortByOptions;
    this.defaultSort = this.tableInputs.defaultSort;
    this._commonService.defaultSort = this.defaultSort;
    const sortArray = [this.sortOrder, this.orderBy];
    this.sortTable(sortArray);
    this.SelectedData = [];
    this.page = 0;
    this.isCustomTableData = false;
    this.getScroll();
    if (this.originalData !== undefined) {
      this.tableData.forEach(element => {
        if (element.checked != null && element.checked === true) {
        this.SelectedData.push(element);
        }
      });

      if (this.originalData.length < 2 && !this.searchApplied && !this._commonService.iconShow) {
        this.showSearch = false;
      }
      if (this.filterArray && Array.isArray(this.filterArray)) {
        this.filter = this.filterArray.map(value => ({ 'key': value.jsonKey, 'val': [] }));
        // this.reservedFilter(this.filterArray);
      }
      this.getGetAllTableData(this.tableData);
      if (this.showHeader) {
        this.setTableWidth();
      }
      this.showNodata = !(this.originalData.length > 0);
      this.cdRef.detectChanges();
    } else {
      this.showNodata = true;
    }

    setTimeout(() => {
      const tableBody = document.getElementsByClassName('table-body')[0] as HTMLElement;
      if (tableBody) {
        let minTableBodyHeight = 0;
        if (this.tableData.length >= 3) {
          minTableBodyHeight = 100 * (this.tableData.length === 0 ? 2 : 3);
        } else if (this.tableData.length === 2 || this.tableData.length === 1) {
          minTableBodyHeight = 100 * (this.tableData.length === 0 ? 4 : 3);
        } else if (this.tableData.length === 0) {
          minTableBodyHeight = 200
        }
      tableBody.style.setProperty('minHeight', minTableBodyHeight + 'px', 'important' )
      }
    }, 1);

this.updateTableHeight();

  }

  // scrollPositionChange() {
  //   if (document.getElementsByClassName('table-row').length > 0) {
  //     this.rowHeight = document.getElementsByClassName('table-row')[0]['offsetHeight'];
  //   }
  //   if (!this.tableInputs.isInventoryDetails && this.tableInputs.tableId !== 'requsitionDetails' && this.tableInputs.tableId !== 'transfer-list') {
  //     const windowHeight =  window.innerHeight;
  //   const scrollPosition = document.getElementsByClassName('scrollable-content')[0]['style'].transform.split('(')[1];
  //   const title = document.getElementsByClassName('title-view').length > 0 ?
  //    document.getElementsByClassName('title-view')[0]['offsetHeight'] : 0;
  //   const tilesHeight = document.getElementsByClassName('tile-component').length > 0  ?
  //    document.getElementsByClassName('tile-component')[0]['offsetHeight'] : 0;
  //   const headerHeight = document.getElementsByClassName('header').length > 0 ?
  //    document.getElementsByClassName('header')[0]['offsetHeight'] : 0;
  //   const matTabHeader = document.getElementsByClassName('mat-tab-header').length > 0 ?
  //    document.getElementsByClassName('mat-tab-header')[0]['offsetHeight'] : 0;
  //   const itemListTitle = document.getElementsByClassName('item-list-title').length > 0 ?
  //    document.getElementsByClassName('item-list-title')[0]['offsetHeight']  : 0;
  //   const itemSummaryHeight = document.getElementsByClassName('item-summary').length > 0 ?
  //    document.getElementsByClassName('item-summary')[0]['offsetHeight'] : 0;
  //   const totalAvailableHeight = windowHeight - (title + tilesHeight + headerHeight + matTabHeader + itemListTitle + itemSummaryHeight);
  //   const transformPixel = scrollPosition.slice(0, scrollPosition.length - 3);
  //   if (Number(transformPixel) < totalAvailableHeight) {
  //     if (this.currentTransformPixel !== transformPixel && transformPixel !== '0') {
  //       const virtualTableHeight = document.getElementsByClassName('table-body')[0]['offsetHeight'];
  //       document.getElementsByClassName('table-body')[0]['style']['height'] = totalAvailableHeight + 'px';
  //       document.getElementsByClassName('section-container')[0].scrollTop = Number(transformPixel);
  //       this.currentTransformPixel = transformPixel;
  //     }
  //     }
  //   } else if (this.tableInputs.isInventoryDetails) {
  //     const scrollPositionInv = document.getElementsByClassName('scrollable-content')[0]['style'].transform.split('(')[1];
  //     const title = document.getElementsByClassName('title-view').length > 0 ? document.getElementsByClassName('title-view')[0]['offsetHeight'] : 0;
  //     const windowHeight =  window.innerHeight;
  //     const inventoryTabHeight = document.getElementsByClassName('inventory-tabs').length > 0 ? document.getElementsByClassName('inventory-tabs')[0]['offsetHeight'] : 0;
  //     const inventoryItemsHeight = document.getElementsByClassName('inventory-item-details').length > 0 ?  document.getElementsByClassName('inventory-item-details')[0]['offsetHeight'] : 0;
  //     const itemListTitle = document.getElementsByClassName('item-list-title').length > 0 ? document.getElementsByClassName('item-list-title')[0]['offsetHeight']  : 0;
  //     const selectSectionHeight = document.getElementsByClassName('select-section').length > 0 ? document.getElementsByClassName('select-section')[0]['offsetHeight'] : 0;
  //     const remainingHeight = windowHeight - (title + inventoryTabHeight + itemListTitle + selectSectionHeight +  5);

  //     const matTabHeader = document.getElementsByClassName('mat-tab-header').length > 0 ?
  //      document.getElementsByClassName('mat-tab-header')[0]['offsetHeight'] : 0;
  //     const unitConversionHeight = document.getElementsByClassName('inventoryunits').length > 0 ? document.getElementsByClassName('unitconversions')[0]['offsetHeight'] : 0;
  //     const totalScrollHeight = inventoryItemsHeight + matTabHeader + unitConversionHeight;
  //     const transformPixel = scrollPositionInv.slice(0, scrollPositionInv.length - 3);
  //     if (this.currentTransformPixel !== transformPixel && transformPixel !== '0') {
  //       const totalRowsHeight = this.tableData.length * this.rowHeight;
  //       if (remainingHeight > totalRowsHeight) {
  //         document.getElementsByClassName('table-body')[0]['style']['height'] = totalRowsHeight + 'px';
  //       } else {
  //         document.getElementsByClassName('table-body')[0]['style']['height'] = remainingHeight + 'px';
  //       }
  //       document.getElementsByClassName('section-container')[0].scrollTop = totalScrollHeight;
  //       this.currentTransformPixel = transformPixel;
  //     }
  //   } else {
  //     const scrollPosition = document.getElementsByClassName('scrollable-content')[0]['style'].transform.split('(')[1];
  //     const transformPixel = scrollPosition.slice(0, scrollPosition.length - 3);
  //     const windowHeight =  window.innerHeight;
  //     const title = document.getElementsByClassName('title-view').length > 0 ? document.getElementsByClassName('title-view')[0]['offsetHeight'] : 0;
  //     const itemSummary = document.getElementsByClassName('item-summary').length > 0 ? document.getElementsByClassName('item-summary')[0]['offsetHeight'] : 0;
  //     const itemListTitle = document.getElementsByClassName('item-list-title').length > 0 ? document.getElementsByClassName('item-list-title')[0]['offsetHeight']  : 0;
  //     const copyButtonHeight = document.getElementsByClassName('copy-button').length > 0 ?
  //      document.getElementsByClassName('copy-button')[0]['offsetHeight']  : 0;
  //     const remainingHeight = windowHeight - (title + itemListTitle + copyButtonHeight + 20);
  //     const totalScrollHeight = itemSummary + 20; // 20 is margin of item-list
  //     if (this.currentTransformPixel !== transformPixel && transformPixel !== '0') {
  //       document.getElementsByClassName('table-body')[0]['style']['height'] = remainingHeight + 'px';
  //       document.getElementsByClassName('section-container')[0].scrollTop = Number(transformPixel) === 0 ? 0 : totalScrollHeight;
  //       this.currentTransformPixel = transformPixel;
  //     }
  //   }
  // }
  updateTableHeight(index?) {
    // debugger;
    // const defaultRowHeight = 83;
    // let _this = this;
    // setTimeout(() => {
    //   if(document.getElementsByClassName('collapse')[0]) {
    //   const titleHeight = document.querySelector('.title-view') ? document.querySelector('.title-view').clientHeight : 0;
    //   const addSearchHeight = document.querySelector('.add-item') ? document.querySelector('.add-item').clientHeight : 0;
    //   const requestButtonHeight = document.querySelector('.request-details-mobile') ?
    //                               document.querySelector('.request-details-mobile').clientHeight : 0;
    //   const itemSummaryHeight = document.querySelector('.item-summary') ? document.querySelector('.item-summary').clientHeight : 0;
    //   const overallHeight = window.innerHeight - (titleHeight + addSearchHeight + requestButtonHeight + itemSummaryHeight);
    //   // const isTableRowAvaiable = ;
    //   const collapseHeight = document.getElementsByClassName('collapse')[0] ?
    //  document.getElementsByClassName('collapse')[0]['clientHeight'] : 0;
    //   const rowHeight =  document.getElementsByClassName('table-row')[0] ?
    //  document.getElementsByClassName('table-row')[0]['offsetHeight']: defaultRowHeight;
    //   const totalRowCount = rowCount ? rowCount : this.tableData.length;
    //   const allRowsHeight = rowHeight * totalRowCount;
    //   const isCollapseAvailable = _this.tableData.filter(x => x.collapse === false);
    //   const isCollapse = isCollapseAvailable ? isCollapseAvailable.length : 0;
    //   if (allRowsHeight > overallHeight) {
    //      document.getElementsByClassName('table-body')[0]['style'].height = isCollapse > 0 ? `${overallHeight}px` : `${overallHeight}px`;
    //   } else {
    //     document.getElementsByClassName('table-body')[0]['style'].height = isCollapse > 0 ? `${allRowsHeight + 117}px` :
    //     (collapseHeight > 0 ? `${collapseHeight * rowCount}px` : `${allRowsHeight}px`);
    //   }
    //   if (this.scrollOffSetHeight) {
    //     this.viewport1.scrollToOffset(this.scrollOffSetHeight, 'auto');
    //   }
    // }
    // }, 5);
    let timeoutValue = 5;
    if (this.deviceInfo.device === 'iPhone') {
      timeoutValue = 100;
    }
    const _this = this;
    if (this.intial) {
      setTimeout(() => {
        if (document.getElementsByClassName('table-row').length > 0) {
      _this.rowHeight = document.getElementsByClassName('table-row')[0]['offsetHeight'];
      _this.intial = false;
        }
      }, timeoutValue);
    }
    const windowHeight =  window.innerHeight;
    const title = document.getElementsByClassName('title-view').length > 0 ?
     document.getElementsByClassName('title-view')[0]['offsetHeight'] : 0;
    const addItem = document.getElementsByClassName('add-item').length > 0 ?
     document.getElementsByClassName('add-item')[0]['offsetHeight'] : 0;
    const itemSummary = document.getElementsByClassName('item-summary').length > 0 ?
     document.getElementsByClassName('item-summary')[0]['offsetHeight'] : 0;
    const itemListTitle = document.getElementsByClassName('item-list-title').length > 0 ?
     document.getElementsByClassName('item-list-title')[0]['offsetHeight']  : 0;
    const customSearch = document.getElementsByClassName('custom-search-tab').length > 0 ?
     document.getElementsByClassName('custom-search-tab')[0]['offsetHeight']  : 0;
    const tabList = document.getElementsByClassName('inventory-tabs').length > 0 ?
     document.getElementsByClassName('inventory-tabs')[0]['offsetHeight']  : 0;
    const tilesHeight = document.getElementsByClassName('tile-component').length > 0  ?
     document.getElementsByClassName('tile-component')[0]['offsetHeight'] : 0;
    const headerHeight = document.getElementsByClassName('header').length > 0 ?
     document.getElementsByClassName('header')[0]['offsetHeight'] : 0;
    const matTabHeader = document.getElementsByClassName('mat-tab-header').length > 0 ?
     document.getElementsByClassName('mat-tab-header')[0]['offsetHeight'] : 0;
    const remainingHeight = this.tableId === 'allLocations' ? windowHeight :
    windowHeight - (title + addItem + itemSummary + itemListTitle + customSearch + tabList + tilesHeight + headerHeight + matTabHeader);

     setTimeout(() => {


      const rowCount = _this.tableData.length;
      // if(rowCount > 1){
      //   if(document.getElementsByClassName('table-row')[0].clientHeight >  document.getElementsByClassName('table-row')[1].clientHeight){
      //     rowHeight = document.getElementsByClassName('table-row')[1].clientHeight;
      //   }

      // }
      // Fix for 15269
      const defaultRowCount = 8;
      _this.index = -1;
      const actualRowHeight = _this.rowHeight * rowCount ;
      const defaultHeight = _this.rowHeight * (rowCount < defaultRowCount ? rowCount : defaultRowCount);
      const tableId = document.getElementById('app-tale-body-' + this.tableId);
      if (tableId) {
        if (!this.tableInputs.isInventoryDetails) {
        if (actualRowHeight < remainingHeight) {
          document.getElementById('app-tale-body-' + this.tableId).style.height = actualRowHeight + 'px';
          // console.log('actualRowHeight', actualRowHeight);
        } else {
          if (remainingHeight > defaultHeight) {
          document.getElementById('app-tale-body-' + this.tableId).style.height = remainingHeight  + 'px';
          // console.log('remainingHeight', remainingHeight);
          } else {
          document.getElementById('app-tale-body-' + this.tableId).style.height = defaultHeight + 'px';
          // console.log('defaultHeight', defaultHeight);
          }
        }
      } else {
        if (remainingHeight > actualRowHeight) {
          document.getElementById('app-tale-body-' + this.tableId).style.height = actualRowHeight + 'px';
          // console.log('actualRowHeight', actualRowHeight);
        } else {
          document.getElementById('app-tale-body-' + this.tableId).style.height = remainingHeight + 'px';
          // console.log('remainingHeight', remainingHeight);
        }
      }
    }


     }, (timeoutValue + 10));
    // if(remainingHeight > )


  }


  ngAfterViewInit() {
    const ifSearchbar = document.getElementsByClassName('fixed-search-bar');
    if (ifSearchbar.length > 0) {
      ifSearchbar[0].remove();
    }
    this.windowHeight = window.innerHeight;
    if (this.showHeader) {
      this.setTableWidth();
    }
    /*  this.checkLocationsWidth(); */
    this.cdRef.detectChanges();
    this.sortByOptions = this.tableInputs.sortByOptions;
    if (this.filterArray && Array.isArray(this.filterArray)) {
      this.filter = this.filterArray.map(value => ({ 'key': value.jsonKey, 'val': [] }));
      // this.reservedFilter(this.filterArray);
    }
    if (this.resizeWidth) {
      const table = document.getElementById(this.resizeParameters.id);
      if (table) {
        const price = table.getElementsByClassName(`data-${this.resizeParameters.showKey}`);
        const supplierName = table.getElementsByClassName(`data-${this.resizeParameters.resizeKey}`);
        if (price.length > 0) {
          for (let itemList = 0; itemList < price.length; itemList++) {
            const pricewidth = price[itemList].clientWidth;
            (<HTMLElement>supplierName[itemList]).style.width = 'calc(100% - ' + (pricewidth + 30) + 'px)';
          }
        }
      }
    }
    setTimeout(() => {
      const tableBody = document.getElementsByClassName('table-body')[0] as HTMLElement;
      let minTableBodyHeight = 0;
      if (this.tableData.length >= 3) {
        minTableBodyHeight = 100 * (this.tableData.length === 0 ? 2 : 3);
      } else if (this.tableData.length === 2 || this.tableData.length === 1) {
        minTableBodyHeight = 100 * (this.tableData.length);
      } else if (this.tableData.length === 0) {
        minTableBodyHeight = 200
      }
      tableBody.style.setProperty('minHeight', minTableBodyHeight + 'px', 'important' )
    }, 1);

    this.updateTableHeight();
  }

  heightcalc(tableData) {
    try{
      if (this.tableData.length >= 3) {
        return 100 * (tableData.length === 0 ? 2 : 3) +  'px !important';
      } else if (this.tableData.length === 2 || this.tableData.length === 1) {
        return 100 * (tableData.length) +  'px !important';
      } else if (this.tableData.length === 0) {
        return 100 + '% !important';
      } 
    } catch (exception) {
      return 200 + 'px !important'
    }
  }


  RowSelect(event, SelectedRow, Frm) {
    if (Frm === 'All') {
      if (event.target.checked === true) {
        this.SelectedData = [];
        for (let l = 0; l < this.tableData.length; l++) {
          this.tableData[l].checked = event.target.checked;
          this.SelectedData.push(this.tableData[l]);
        }
      } else {
        this.SelectedData = _.difference(this.SelectedData, this.tableData);
      }
    } else {
      SelectedRow.checked = event.target.checked;
      if (this.SelectedData.indexOf(SelectedRow) === -1) {
        this.SelectedData.push(SelectedRow);
      } else {
        this.SelectedData.splice(this.SelectedData.indexOf(SelectedRow), 1);
      }
      this.IsCheckAll = (_.difference(this.tableData, this.SelectedData).length === 0);
    }


    this.RowSelectEmitter.emit(this.SelectedData);
    this.CurrentRowSelectedEmitter.emit({ 'event': event, 'SelectedRow': SelectedRow, 'From': Frm });
  }





  rowClicked(event, data) {
    if (event.target.tagName.toLowerCase() !== 'input') {
      this.RowClicked.emit(data);
    }


  }


  receivedData(event) {
        this.showNodata = false;
    this.sortData = event;
    this.customTableData = event;
    this.isCustomTableData = true;
    this.tableData = [];
    this.tableData = event;
    this.page = 0;
    this.getScroll();


    if (!event || event.length === 0) {
      this.showNodata = true;
    }
    this.updateTableHeight();

  }
  apiSearchOption(event) {
    event = event === '' ? 'fromClear' : event;
    this.apiSearchemit.emit(event);
  }
  clearSearch() {
    if (this._commonService.iconShow) {
      this.isCustomTableData = true;
      this.customTableData = this.searchData;
      this.sortData = this.searchData;
      this.tableData = this.searchData;
    } else {
      this.isCustomTableData = false;
      this.tableData = this.originalData;
    }
    if (this.searchParms.SearchApplied === true) {
      this._commonService.searchValue = '';
      this.apiSearchemit.emit('fromClear');
    }
    // this.tableData = [];
    this.page = 0;
    this.getScroll();
    this.showNodata = !(this.tableData.length > 0);
    this.updateTableHeight();
  }

  moreOptionsClicked(event, name) {
    this.MoreOptionsClicked.emit([event, name]);
  }

  sortTable(event) {
    this.orderBy = event[1];
    this.sortOrder = event[0];
    this.sortEmit.emit(event);    
    if(!this._commonService.isonlineStatus || this._commonService.isOffline){
      if ( event[0] === 'aesc') {
      this.tableData.sort((a, b) =>  -(a[this.orderBy] < b[this.orderBy]) || + (a[this.orderBy] !== b[this.orderBy]));
      this.tableData = [...this.tableData];
    } else {
      this.tableData.sort((a, b) => -(a[this.orderBy] > b[this.orderBy]) || +(a[this.orderBy] !== b[this.orderBy]));
      this.tableData = [...this.tableData];
    }    
    }
    else{
      this.tableData = [...this.tableData];
    }
    // Do not uncomment. If required contact UI team. Fix for retaining filter data navigating from details section.
    // this.tableInputs.tableData = this.tableData;
  }

  sortedData(event) {
    this.isCustomTableData = true;
    this.customTableData = event;
    // this.tableData = [];
    this.page = 0;
    this.getScroll();
  }

  clickFilter(event) {
    this.checkStatusToFilter.emit(event);
  }

  clickSort(event) {
    this.checkStatusToSort.emit(event);
  }
  emitOffineNodataforSearch() {
    this.emitOffineforSearch.emit();
  }

  sync(event){
    this.syncEmitter.emit(event);
  }

  isHeaderVisible(header: any) {
    const headerArray = ['qor', 'priorityId', 'transTypeId', 'showCancel', 'authorized', 'showMore'];
    return !headerArray.includes(header);
  }
  
  onScroll(event: any) {
    const scrollTop = event.target.scrollTop;  // current scroll position
    const scrollHeight = event.target.scrollHeight;  // total scrollable height
    const clientHeight = event.target.clientHeight;  // visible area height

    if (scrollTop + clientHeight >= scrollHeight) {
      const totalTableCount = this.tableInputs.totalCount;
      if (this.tableInputs.tableData.length < totalTableCount) {
        this.tableInputs.bottomReached(this.tableData.length)
      }
    }
  }

}
